import React from 'react';
import {Card, Typography, Grid} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({

  CardStyle:{
    borderRadius:'15px',
    margin:'10px',
    padding:'30px',
    maxWidth:'100%'
  },

  title:{
    color:'#153BAB',
    fontFamily:['Nunito'].join(','),
    fontWeight:600
  },

  info:{
    fontFamily:['Nunito'].join(','),
    marginLeft:'40px',
    color:'black',
    fontWeight:400
  }

}));

const JobInfoCard = (props) =>{
  const classes = useStyles();
  return (

    <Card className={classes.CardStyle}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Typography className={classes.title}>Title: 
          <span className={classes.info}>{props.Location}</span>
          </Typography>
        </Grid>
        <Grid item xs={6}>
        <Typography className={classes.title}> Company:
        <span className={classes.info}>{props.level}</span>
        </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.title}>Job Type:
          <span className={classes.info}>{props.job}</span>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.title}>Phone:
          <span className={classes.info}>{props.Elevel}</span>
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

export default JobInfoCard;
// <div className={classes.Horizontalcontainer}>
//   <div className={classes.container}>
//     <Typography className={classes.title}>Location: </Typography>
//     <Typography className={classes.info}>{props.Location}</Typography>
//   </div>
//   <div className={classes.container}>
//     <Typography className={classes.title}>Job Type: </Typography>
//     <Typography className={classes.info} >{props.job}</Typography>
//   </div>
// </div>
// <div className={classes.Horizontalcontainer}>
//   <div className={classes.Horizontalcontainer}>
//     <Typography className={classes.title}>Level: </Typography>
//     <Typography className={classes.info} >{props.level}</Typography>
//   </div>
//   <div className={classes.Horizontalcontainer}>
//     <Typography className={classes.title}>Education Level: </Typography>
//     <Typography className={classes.info} >{props.Elevel}</Typography>
//   </div>
// </div>
